import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IdiomaHomeService {
  
  private data2: any;
  constructor() { }


  getEspañol(data : any){
    this.data2 = new Array(data);
    if (this.data2 != null) {
      //this.infoC = new InfoC(this.data2[0].default.Usat[0].id, this.data2[0].default.Usat[0].nombre, this.data2[0].default.Usat[0].titulo, this.data2[0].default.Usat[0].descripcion, this.data2[0].default.Usat[0].imagen)
    console.log(this.data2);
    
    }
  }

  getIngles(dataIn: any):void{
    console.log("ejecutando el cambio de idioma a ingles.");
    this.data2 = new Array(dataIn);
    if(this.data2 != null){
      //this.infoC = new InfoC(this.data2[0].default.Usat[0].id, this.data2[0].default.Usat[0].nombre, this.data2[0].default.Usat[0].titulo, this.data2[0].default.Usat[0].descripcion, this.data2[0].default.Usat[0].imagen)
      console.log(this.data2);
    }   
  }

  getChino():void{
    console.log("ejecutando el cambio de idioma a chino");
  }
}
